<template>
  <v-card class="tutorial-card" elevation="12">
    <v-card-title class="tutorial-title d-flex align-center">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
      <v-btn density="compact" icon="mdi-close" variant="text" @click="$emit('close')"></v-btn>
    </v-card-title>
    <v-card-text class="tutorial-description">
      <div v-html="descricao"></div>
    </v-card-text>
    <v-card-actions class="d-flex justify-space-between">
      <v-btn v-if="!ehPrimeiroPasso" size="small" @click="$emit('anterior')">
        Voltar
      </v-btn>
      <v-spacer v-else></v-spacer>
      <v-btn color="primary" size="small" @click="$emit('proximo')">
        {{ ehUltimoPasso ? 'Finalizar' : 'Próximo' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
defineProps({
  titulo: String,
  descricao: String,
  ehPrimeiroPasso: Boolean,
  ehUltimoPasso: Boolean,
});

defineEmits(['proximo', 'anterior', 'close']);
</script>

<style>
.tutorial-card {
  max-width: 350px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.tutorial-title {
  font-size: 1.25rem !important;
  font-weight: 500;
  line-height: 1.4;
}
.tutorial-description {
  font-size: 1rem !important;
  line-height: 1.6;
}
</style>
